import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
// 解决重复点击相同路由报错
const VueRouterPush = VueRouter.prototype.push;
/* NOSONAR */ VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
const constantRoute = [
  {
    path: "/",
    redirect: "home"
  },
  {
    path: "/home",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "@/views/home"),
    meta: {
      title: "首页"
    }
  },
  {
    path: "/case/:id",
    name: "case",
    component: () => import(/* webpackChunkName: "case" */ "@/views/case"),
    meta: {
      title: "案例"
    },
    props: true
  },
  {
    path: "*",
    redirect: "/"
  }
];

const createRouter = () =>
  new VueRouter({
    mode: "hash",
    scrollBehavior: () => ({ y: 0 }),
    routes: [...constantRoute]
  });

const router = createRouter();

export default router;
